/* unplugin-vue-components disabled */import script from "./KpiSkeletonRow.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiSkeletonRow.vue?vue&type=script&setup=true&lang=js"

import "./KpiSkeletonRow.vue?vue&type=style&index=0&id=f5c36590&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5c36590"]])

export default __exports__